export default {
    dir: (message, ...optionalParams) => console.dir(message, optionalParams),
    log: (message, ...optionalParams) => console.log(message, optionalParams),
    warn: (message, ...optionalParams) => console.warn(message, optionalParams),
    error: (message, ...optionalParams) => console.error(message, optionalParams),
    assert: (condition, message, ...optionalParams) => console.assert(condition, message, optionalParams)
}
